import { render, staticRenderFns } from "./dscj.vue?vue&type=template&id=91b78cf6&scoped=true"
import script from "./dscj.vue?vue&type=script&lang=js"
export * from "./dscj.vue?vue&type=script&lang=js"
import style0 from "./dscj.vue?vue&type=style&index=0&id=91b78cf6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "91b78cf6",
  null
  
)

export default component.exports